import React, { useState } from 'react'
import { styled } from '@material-ui/core/styles'
import { AppBar, Container, Drawer, IconButton, Toolbar, Typography } from '@material-ui/core'
import { Menu } from '@material-ui/icons'
import { Navigation } from './Navigation'
import { Logo } from './logo/Logo'

const Hamburger = styled(IconButton)(({ theme: { spacing } }) => ({
  marginRight: spacing(2),
}))

const Title = styled(Typography)({
  flexGrow: 1,
  fontFamily: 'Satisfy, Roboto, Helvetica, Arial, sans-serif',
})

export const Header = (props) => {
  const [state, setState] = useState(false)

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }

    setState(open)
  }

  return (
    <React.Fragment>
      <AppBar position="static">
        <Container>
          <Toolbar>
            <Hamburger
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
            >
              <Menu />
            </Hamburger>
            <Title variant="h5">
              Bethany Language Services
            </Title>
            <Logo />
          </Toolbar>
        </Container>
      </AppBar>
      <Drawer open={state} onClose={toggleDrawer(false)}>
        <Navigation {...props} />
      </Drawer>
    </React.Fragment>
  )
}
